import { CALL_API } from "../../middlewares/api";
import { get_terminated_loans } from "./terminatedLoansActions";

export const SALE_FILES_REQUEST = "SALE_FILES_REQUEST";
export const SALE_FILES_SUCCESS = "SALE_FILES_SUCCESS";
export const SALE_FILES_ERROR = "SALE_FILES_ERROR";

export function load_files() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/list-request-batches-sale",
      authenticatedRequest: true,
      method: "GET",
      types: [SALE_FILES_REQUEST, SALE_FILES_SUCCESS, SALE_FILES_ERROR],
    },
  };
}

export const SALE_CREATE_FILES_REQUEST = "SALE_CREATE_FILES_REQUEST";
export const SALE_CREATE_FILES_SUCCESS = "SALE_CREATE_FILES_SUCCESS";
export const SALE_CREATE_FILES_ERROR = "SALE_CREATE_FILES_ERROR";

export function create_files() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/build-sale-request-batch",
      authenticatedRequest: true,
      method: "POST",
      types: [SALE_FILES_REQUEST, { method: filesCreated }, SALE_FILES_ERROR],
    },
  };
}

function filesCreated(response) {
  return (dispatch) => {
    dispatch({ type: SALE_CREATE_FILES_SUCCESS, response });
    dispatch(load_files());
  };
}

export const SALE_LOAD_FILE_DETAILS_REQUEST = "SALE_LOAD_FILE_DETAILS_REQUEST";
export const SALE_LOAD_FILE_DETAILS_SUCCESS = "SALE_LOAD_FILE_DETAILS_SUCCESS";
export const SALE_LOAD_FILE_DETAILS_ERROR = "SALE_LOAD_FILE_DETAILS_ERROR";

export function load_file_details(id) {
  return {
    [CALL_API]: {
      method: "GET",
      endpoint: "/api/admin/debt-agency/request-batch-details?BatchId=" + id,
      authenticatedRequest: true,
      data: { BatchId: id },
      types: [
        SALE_LOAD_FILE_DETAILS_REQUEST,
        SALE_LOAD_FILE_DETAILS_SUCCESS,
        SALE_LOAD_FILE_DETAILS_ERROR,
      ],
    },
  };
}

export const SALE_FINALIZE_FILE_REQUEST = "SALE_FINALIZE_FILE_REQUEST";
export const SALE_FINALIZE_FILE_SUCCESS = "SALE_FINALIZE_FILE_SUCCESS";
export const SALE_FINALIZE_FILE_ERROR = "SALE_FINALIZE_FILE_ERROR";

export function finalize_file(id) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/finalize-batch",
      authenticatedRequest: true,
      method: "POST",
      data: { BatchId: id },
      types: [
        SALE_FINALIZE_FILE_REQUEST,
        SALE_FINALIZE_FILE_SUCCESS,
        SALE_FINALIZE_FILE_ERROR,
      ],
    },
  };
}

export const SALE_REMOVE_LOAN_FROM_FILE_REQUEST =
  "SALE_REMOVE_LOAN_FROM_FILE_REQUEST";
export const SALE_REMOVE_LOAN_FROM_FILE_SUCCESS =
  "SALE_REMOVE_LOAN_FROM_FILE_SUCCESS";
export const SALE_REMOVE_LOAN_FROM_FILE_ERROR =
  "SALE_REMOVE_LOAN_FROM_FILE_ERROR";

export function remove_loan_form_file(fileId, loanId) {
  const data = { BatchId: fileId, LoanId: loanId };
  return {
    [CALL_API]: {
      endpoint: "/api/admin/debt-agency/remove-from-batch",
      authenticatedRequest: true,
      data: data,
      method: "POST",
      types: [
        SALE_REMOVE_LOAN_FROM_FILE_REQUEST,
        { method: loanRemoved.bind(this, data) },
        SALE_REMOVE_LOAN_FROM_FILE_ERROR,
      ],
    },
  };
}
function loanRemoved(dataSent, response) {
  return (dispatch) => {
    dispatch({ type: SALE_REMOVE_LOAN_FROM_FILE_SUCCESS, response, dataSent });
    dispatch(get_terminated_loans());
  };
}
